import { claimForCurrentClick } from '@exam-prep/ui';
import { MutationCache } from '@tanstack/react-query';

/**
 * Every mutation started from a Button click (save, retire, approve, upload, generate, sign in…)
 * keeps that button disabled with a spinner until the request settles, without each screen
 * wiring `isPending` by hand.
 */
export function pendingButtonMutationCache(): MutationCache {
  const open = new WeakMap<object, () => void>();
  return new MutationCache({
    onMutate: (_variables, mutation) => {
      let finish = () => {};
      const work = new Promise<void>((resolve) => {
        finish = resolve;
      });
      if (claimForCurrentClick(work)) open.set(mutation, finish);
    },
    onSettled: (_data, _error, _variables, _context, mutation) => {
      open.get(mutation)?.();
      open.delete(mutation);
    },
  });
}
